import React, { useLayoutEffect } from 'react';
import CountUp from 'react-countup';
import img2 from '../../assets/image/img-2.jpg';

const Facts = ({ data }) => {
    useLayoutEffect(() => {
        // Trigger animations for this section
        if (window.animationText) window.animationText();
        if (window.scrollingEffect) window.scrollingEffect();
        if (window.animateImgItem) window.animateImgItem();

        // Refresh ScrollTrigger as content might have changed
        if (window.ScrollTrigger) {
            window.ScrollTrigger.refresh();
        }
    }, [data]);

    return (
        <section className="section-counting tf-spacing-2">
            <div className="mask mask-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="700" height="700" fill="none">
                    <circle cx="350" cy="350" r="285" stroke="url(#a2)" strokeWidth="130" />
                    <defs>
                        <linearGradient id="a2" x1="154" x2="497.875" y1="61.688" y2="589.75">
                            <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                            <stop offset="1" stopColor="#fff" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="tf-container w-1810">
                <div className="section-counting-inner flex">
                    <div className="left">
                        <div className="image tf-animate-1">
                            <img src={data?.image ? (data.image.startsWith('http') ? data.image : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${data.image}`) : img2} alt="Facts" />
                        </div>
                    </div>
                    <div className="right">
                        <div className="heading-section mb-60">
                            <div
                                className="sub-title body-2 fw-7 mb-17 title-animation"
                                dangerouslySetInnerHTML={{ __html: data?.top_title || 'Explore Our Achievement' }}
                            />
                            <h2
                                className="title fw-6 title-animation"
                                dangerouslySetInnerHTML={{
                                    __html: data?.main_title || `WMK TECH <span class="fw-3"> Software Company</span>`
                                }}
                            />
                        </div>
                        <div className="wg-counter flex g-30">

                            <div className="counter-item style-2 style-bg-primary px-md-15">
                                <div className="icon">
                                    <i className="icon-check"></i>
                                </div>
                                <div className="counter">
                                    <div className="number-counter flex fs-65 fw-7">
                                        <span className="number">
                                            <CountUp
                                                key={data?.counter_one}
                                                end={parseInt(data?.counter_one) || 20}
                                                duration={3}
                                                enableScrollSpy
                                                scrollSpyOnce
                                            />
                                        </span>
                                        <span className="title-counter">
                                            {data?.counter_one ? data.counter_one.toString().replace(/[0-9]/g, '') : 'k'}+
                                        </span>
                                    </div>
                                    <h6 className="title-counter lh-30 fw-5">
                                        Trusted Global Clients
                                    </h6>
                                </div>
                            </div>

                            <div className="counter-item style-2 style-bg-surface px-md-15">
                                <div className="icon">
                                    <i className="icon-check"></i>
                                </div>
                                <div className="counter">
                                    <div className="number-counter flex fs-65 fw-7">
                                        <span className="number">
                                            <CountUp
                                                key={data?.counter_two}
                                                end={parseInt(data?.counter_two) || 650}
                                                duration={3}
                                                enableScrollSpy
                                                scrollSpyOnce
                                            />
                                        </span>
                                        <span className="title-counter">
                                            {data?.counter_two ? data.counter_two.toString().replace(/[0-9]/g, '') : ''}+
                                        </span>
                                    </div>
                                    <h6 className="title-counter lh-30 fw-5">
                                        Best Project Complete
                                    </h6>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Facts;
